module.exports = __webpack_public_path__ + "img/review-rating-1.fea51d5a.png";